// extracted by mini-css-extract-plugin
module.exports = {"Background":"CheckOutPage_Background__1dyxp","Features":"CheckOutPage_Features__q533Y"};